import { render, staticRenderFns } from "./OnTopicComment.vue?vue&type=template&id=3056ce6e&"
import script from "./OnTopicComment.vue?vue&type=script&lang=js&"
export * from "./OnTopicComment.vue?vue&type=script&lang=js&"
import style0 from "./OnTopicComment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports